import React from 'react'
import { Steps } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import * as steps from './steps'

interface RegisterUserFormProps { isOnlyOffsetter: boolean }

const RegisterUserForm: React.FC<RegisterUserFormProps> = (props) => {
  const { isOnlyOffsetter } = props
  const { t } = useTranslation()
  const { step: currentStep } = useAppSelector((state) => state.users.registerForm)

  return (
    <>
      <Steps current={currentStep}>
        <Steps.Step title={t('admin.Brokerage.Credentials')} />
        <Steps.Step title={t('admin.Brokerage.PersonalData')} />
      </Steps>
      {currentStep === 0 && <steps.CredentialsFormStep />}
      {currentStep === 1 && <steps.PersonalDataFormStep isOnlyOffsetter={isOnlyOffsetter} />}
    </>
  )
}

export default RegisterUserForm
